import { Button, TextField } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { PopupType } from "../../../../Models/Entities";
import { BASE_URL, sendData } from "../../../../Models/Fetcher";
import {
  codeTableState,
  customerState,
  loggedUserState,
  popupState,
  toastState,
} from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";
import SelectCodeTable from "../../../Select/SelectCodeTable";
import SelectCustomer from "../../../Select/SelectCustomer";

import "./styles.css";

interface IAddFavoritePopup {
  type: PopupType;
}
const useStyles = makeStyles({
  addFavButton: {
    marginTop: "2rem",
  },
});

export default ({ type }: IAddFavoritePopup) => {
  const [selected, setSelectedCustomer] = useRecoilState(customerState);
  const [selectedTable, setSelectedTable] = useRecoilState(codeTableState);
  const classes = useStyles();
  const setPopup = useSetRecoilState(popupState);
  const user = useRecoilValue(loggedUserState);

  const setToast = useSetRecoilState(toastState);

  const { handleSubmit, control } = useForm();

  blurRoot();

  const close = () => {
    unBlurRoot();
    setPopup(null);
    setSelectedCustomer({ id: 0, name: "" });
    setSelectedTable({ id: 0, name: "" });
  };

  const handleCreateFromExisting = async (data: any) => {
    const url = BASE_URL + "codetables";
    const response = await sendData(url, "POST", {
      tableId: selectedTable.id,
      tableName: data.name,
      userId: localStorage.getItem("userId"),
      description: data.description,
    });

    if (response.status === 200) {
      setToast({
        open: true,
        message: response.data.message,
        severity: "success",
      });
    } else {
      setToast({
        open: true,
        message: response.data.message,
        severity: "error",
      });
    }
    close();
  };

  const handleCreateTable = async (data: any) => {
    const url = BASE_URL + "codetables-new";
    const response = await sendData(url, "POST", {
      customerId: selected.id,
      tableName: data.tableName,
      userId: user.id,
      description: data.tableDescription,
    });

    if (response.status === 200) {
      setToast({
        open: true,
        message: response.data.message,
        severity: "success",
      });
    } else {
      setToast({
        open: true,
        message: response.data.message,
        severity: "error",
      });
    }
    close();
  };

  if (type === PopupType.CreateTable) {
    return (
      <div className="add-favorite">
        <SelectCustomer />

        {selected.id !== 0 && (
          <>
            <Controller
              name="tableName"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  label="Table name"
                  value={value}
                  onChange={onChange}
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              rules={{ required: "Name required" }}
            />

            <Controller
              name="tableDescription"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  label="Table Description"
                  value={value}
                  onChange={onChange}
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              rules={{ required: "Description required" }}
            />
          </>
        )}

        {selected.id !== 0 && (
          <Button
            className={classes.addFavButton}
            variant="contained"
            color="primary"
            onClick={handleSubmit(handleCreateTable)}
          >
            Create new table
          </Button>
        )}

        <Button className={classes.addFavButton} onClick={close}>
          Cancel
        </Button>
      </div>
    );
  }

  return (
    <div className="add-favorite">
      <SelectCustomer />
      {selected.id !== 0 && <SelectCodeTable />}

      {selectedTable.id !== 0 && (
        <>
          <Controller
            name="name"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label="Table name"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
            rules={{ required: "Name required" }}
          />

          <Controller
            name="description"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label="Table Description"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
            rules={{ required: "Description required" }}
          />

          <Button
            className={classes.addFavButton}
            variant="contained"
            color="primary"
            onClick={handleSubmit(handleCreateFromExisting)}
          >
            Create new table
          </Button>
        </>
      )}

      <Button className={classes.addFavButton} onClick={close}>
        Cancel
      </Button>
    </div>
  );
};
